import { axios } from '@complispace/cs-design-system';
import moment from 'moment-timezone';

const baseURL = process.env.CONTENT_ENGINE_URL;
const clientBaseUrl = `${baseURL}/app/client`;

const client = {
  // GET /app/client
  async getClient() {
    return axios.get(clientBaseUrl);
  },

  // GET /app/client/app
  async getSubscribedCEApps() {
    return axios.get(`${clientBaseUrl}/app`);
  },

  // GET /ce-admin/client/unpublished
  async getAllAppliedUpdates() {
    return axios.get(`${clientBaseUrl}/unpublished`);
  },

  // GET /app/client/published/complispace
  async getAllComplispaceUpdates() {
    return axios.get(`${clientBaseUrl}/published/complispace`);
  },

  // GET /app/client/parent
  async getClientParent() {
    return axios.get(`${clientBaseUrl}/parent`);
  },

  // GET /app/client/children
  async getClientChildren() {
    return axios.get(`${clientBaseUrl}/children`);
  },

  // GET app/client/children/modules/activated
  async getChildActivatedModules() {
    return axios.get(`${clientBaseUrl}/children/modules/activated`);
  },

  // GET app/client/access-details
  async getClientAccessDetails() {
    return axios.get(`${clientBaseUrl}/access-details`);
  },

  // GET app/client/complilearn/modules/activated
  async getSummaryReport(reportDate) {
    return axios.get(
      `${clientBaseUrl}/report/complilearn?report_date=${reportDate}&report_types=SUMMARY`
    );
  },

  // GET app/client/complilearn/modules/activated
  async getActivityReport(reportDate) {
    return axios.get(
      `${clientBaseUrl}/report/complilearn?report_date=${reportDate}&report_types=ACTIVITY`
    );
  },

  // POST app/client/notify
  async notify(forcePublish, moduleIds) {
    const data = { forcePublish: !!forcePublish, moduleIds };
    return axios.post(`${clientBaseUrl}/notify`, data);
  },

  // GET app/client/user-information
  async getUserLoginInformation(requestQueryParameters) {
    return axios.get(`${clientBaseUrl}/user-information`, {
      params: requestQueryParameters
    });
  },

  // POST app/client/user-information
  async recordUserLoginInformation(userInformation) {
    return axios.post(`${clientBaseUrl}/user-information`, userInformation);
  },

  // PUT app/client/assurance-details
  async saveAssuranceIntegrationDetails(apiKey, tenantName) {
    return axios.put(`${clientBaseUrl}/assurance-details`, {
      assuranceApiKey: apiKey,
      assuranceTenant: tenantName
    });
  },

  // PUT app/client/module-details
  async saveClientModuleDetails(clientModuleDetails, reorderChildSiteModules = false) {
    return axios.put(
      `${clientBaseUrl}/module-details?reorderChildren=${reorderChildSiteModules}`,
      clientModuleDetails
    );
  },

  // GET /app/client/ugc-archived-pages
  async getClientArchivedPages(moduleIds) {
    return axios.get(`${clientBaseUrl}/ugc-archived-pages`, {
      params: {
        moduleIds
      }
    });
  },

  // GET /app/client/content-register
  async getClientContentRegisters(clientIds) {
    return axios.get(`${clientBaseUrl}/content-register`, {
      params: {
        clientIds
      }
    });
  },

  // GET /app/client/content-register/exports
  async getClientContentRegisterCSV(includeChildren) {
    const response = await axios.get(
      `${clientBaseUrl}/content-register/exports?includeChildren=${includeChildren}`,
      { responseType: 'blob' }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'Content_Register.csv');
    document.body.appendChild(link);
    link.click();
  },
  async getClientSetUpReport(type, moduleId, moduleName) {
    const todayDate = moment().format('YYYYMMDD');
    const response = await axios.get(
      `${clientBaseUrl}/context-report/exports?type=${type}&moduleIds=${moduleId}`,
      {
        responseType: 'blob'
      }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${moduleName} (${type}) ${todayDate}.csv`);
    document.body.appendChild(link);
    link.click();
  }
};

export default client;
